
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3.594l.719.688 8 8 1.688 1.719H5.594l1.688-1.719 8-8zm0 2.844l-5.563 5.563h11.125zM5.594 18h20.813l-1.688 1.719-8 8-.719.688-.719-.688-8-8zm4.844 2l5.563 5.563L21.564 20H10.439z"}})])
          )
        }
      }
    